// extracted by mini-css-extract-plugin
export default {"container":"Header_container__f70q2","subtitle":"Header_subtitle__jMHSh"};